module.exports = __webpack_public_path__ + "002be50.webp";